<div>
  <h2>{{Campaign.RequestName}}</h2>
  <div class="flex">
    <h3>{{Campaign.PublicAuditName}}</h3>
    <h3 class="text-grey-900 ml-1">&#64;{{Campaign.LocationName}}</h3>
  </div>

</div>


@for (R of Campaign.Participants; track R) {
  <div class="flex flex-col lg:flex-row mt-2 hover:cursor-pointer" (click)="selectAudit(R.ID)">
    <div class="border my-2 border-grey-900 rounded-lg p-4 w-full hover:border-green-400">
      <div class="flex justify-between">
        <div class="flex flex-col">
          <p>{{R.ParticipantName}}</p>
          @if (R.DateCompleted.length>0) {
            <p class="mt-1 text-grey-900">Completed: {{R.DateCompleted}}</p>
          }
        </div>
        @if (R.MaxScore>0) {
          <app-progress-bar [Score]="R.Score" [MaxScore]="R.MaxScore"></app-progress-bar>
          }
        </div>
      </div>
    </div>
  }